import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import store from '@/store/index'

export default {
  GET_ALL_CONTRACTORS({ commit, state }) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.contractors.all}`, {}, true).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data.items
          commit('setContractors', data)
        } else {
          throw response
        }
      },
    )
  },

  GET_CONTRACTOR({ commit, state }, contractorID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.contractor.one.replace('$1', contractorID)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const contractor = response.data.data
        commit('setContractor', contractor)
        commit('setTitle', contractor.name_full)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },

  UPDATE_CONTRACTOR: ({ commit, state }) => {
    commit('setLoad', true)

    const params = {
      address_actual: state.contractor.address_actual,
      company_id: state.contractor.company_id,
      address_legal: state.contractor.address_legal,
      name_full: state.contractor.name_full,
    }
    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.contractor.one.replace('$1', state.contractor.id)}`,
      params,
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        commit('setLoad', false)
        store.dispatch('GET_ALL_CONTRACTORS')

        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.savedMessage,
        })
      } else {
        // TODO: Show error dialog
      }
    })
  },
  CREATE_CONTRACTOR: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.contractors.all}`,
      {
        company_id: state.contractor.company_id,
        name_full: state.contractor.name_full,
        address_legal: state.contractor.address_legal,
        address_actual: state.contractor.address_actual,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setContractorField', { key: 'id', value: data.id })
        commit('setTitle', data.name_full)
        commit('unshiftContractors', { ...state.contractor })
        router.push({ path: Vue.config.modules.crm.route.contractors.one.replace('$1', data.id), hash: '#tab-0' })
        commit('setLoad', false)

        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.savedMessage,
        })
      } else {
        // TODO: Show error dialog
      }
    })
  },
  DELETE_CONTRACTOR: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.contractors.one.replace('$1', state.contractor.id)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        commit('deleteContractor', state.contractor.id)
        const contractorsLength = state.contractors.length

        if (contractorsLength != 0) {
          commit('setContractor', state.contractors[0])
          commit('setContractorField', { key: 'id', value: state.contractors[0].id })
          commit('setTitle', state.contractors[0].name_full)

          commit('setLoad', false)

          router.push({ path: Vue.config.modules.crm.route.contractors.one.replace('$1', state.contractors[0].id) })

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.deleteMessage,
          })
        } else {
          router.push({ path: Vue.config.modules.crm.route.contractors.all })
        }
      } else {
        commit('setLoad', false)

        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'error',
          text: Vue.config.localization.ru.notFoundMessage,
        })
        // TODO: Show error dialog
      }
    })
  },
}
